import React, { useEffect, useContext } from 'react';
import { useApi } from '../../Hooks/useApi'
import { useParams, Outlet } from "react-router-dom";
import SiteSetting from '../../Context/SiteSetting';
import { useState } from 'react';
import './Template.scss';
import ReactGA from "react-ga4";

const Main = () => {
  const api = useApi();
  const { account } = useParams();
  const context = useContext(SiteSetting);
  const [setting, setSetting] = useState(null);
  ReactGA.initialize('G-5QWTHB911L');

  useEffect(()=>{
    if(account) {
      api.getAccount(account).then(data=>{
        context.onUpdateSetting(data.data);
        setSetting(data.data);
      })
    }
  },[account])
  
  if(setting) {
    if(!localStorage.getItem('lang'))localStorage.setItem('lang', 'he');
    document.documentElement.style.setProperty('--primary-color', setting.primary_color);
    document.documentElement.style.setProperty('--secondary-color', setting.secondary_color);
    document.documentElement.setAttribute('direction-mode',localStorage.getItem('lang') === 'he' ? 'rtl' : 'ltr');
  }

  return (<>
    {setting && 
        <div className="main">
            <Outlet />
        </div>
    }
    </>);
};

export default Main;
